import React from 'react'

const Search: React.FC = () => {
  return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 14 14"><path fill="#000000" d="m15.683 14.6 3.265 3.265a.2.2 0 0 1 0 .282l-.8.801a.2.2 0 0 1-.283 0l-3.266-3.265a5.961 5.961 0 1 1 1.084-1.084zm-4.727 1.233a4.877 4.877 0 1 0 0-9.754 4.877 4.877 0 0 0 0 9.754z"></path></svg>
    )
}

export default Search